module.exports = {
    LIST        : 'list-tour',
    TABLE       : 'table-tour',
    BOARD       : 'board-tour',
    CALENDAR    : 'calendar-tour',
    GANTT       : 'gantt-tour',
    WORKLOAD    : 'workload-tour',
    MY_WORK     : 'my-work-week',

    //New
    MAP         : 'map-tour',

    availableTours: ['list-tour', 'table-tour', 'board-tour', 'calendar-tour', 'gantt-tour', 'workload-tour','my-work-week', 'map-tour']
};
